import { useEffect, useRef, useState } from 'react';
import { create, PlayerEventType, type Player } from 'amazon-ivs-player';
import wasmBinary from 'amazon-ivs-player/dist/assets/amazon-ivs-wasmworker.min.wasm?url';
import wasmWorker from 'amazon-ivs-player/dist/assets/amazon-ivs-wasmworker.min.js?url';
import { api } from './api.js';

export function RecordingPlayer({ recordingId }: { recordingId: string }) {
  const videoRef = useRef<HTMLVideoElement>(null);
  const playerRef = useRef<Player | undefined>(undefined);
  const [error, setError] = useState('');

  useEffect(() => () => playerRef.current?.delete(), []);

  const play = async () => {
    setError('');
    try {
      const authorization = await api.authorizeRecording(recordingId);
      const video = videoRef.current;
      if (!video) return;
      const isIos = /iPad|iPhone|iPod/.test(navigator.userAgent);
      if (isIos) {
        video.src = authorization.mediaUrl;
        await video.play();
        return;
      }
      playerRef.current?.delete();
      const player = create({ wasmWorker, wasmBinary });
      playerRef.current = player;
      player.attachHTMLVideoElement(video);
      player.setRequestCredentials('same-origin');
      player.addEventListener(PlayerEventType.ERROR, (playerError) => setError(playerError.message));
      player.load(authorization.mediaUrl);
      player.play();
    } catch (caught) {
      setError(caught instanceof Error ? caught.message : '録画再生に失敗しました');
    }
  };

  return (
    <div>
      <video ref={videoRef} className="video" controls playsInline crossOrigin="use-credentials" />
      <button className="primary" onClick={() => void play()}>署名Cookieを取得して再生</button>
      {error && <p className="error">{error}</p>}
    </div>
  );
}
